module.exports = __webpack_public_path__ + "img/bed21-512.b319bd27.png";